// extracted by mini-css-extract-plugin
export default {"loadingIcon":"_loading_loadingIcon_AMqEF"};